module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2qrYq"))).then(() => parcelRequire('1iHdE'));